"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarSectionHeader = exports.SidebarSectionHeaderDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var icon_1 = require("../elements/icon");
var use_icons_1 = require("../../hooks/use-icons");
var react_spinners_1 = require("react-spinners");
exports.SidebarSectionHeaderDefaultProps = {
  isOpen: false,
  isLoading: true,
  onClick: function () {}
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    color: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n    padding: ", ";\n    ", ";\n    ", ";\n    \n    ", "\n\n    &:hover {\n      color: ", ";\n      ", ";\n    }\n  "], ["\n    color: ", ";\n    color: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n    padding: ", ";\n    ", ";\n    ", ";\n    \n    ", "\n\n    &:hover {\n      color: ", ";\n      ", ";\n    }\n  "])), theme_1.theme.COLOR('text-sidebar'), theme_1.theme.COLOR('primary'), theme_1.theme.FONT_SIZE(15), theme_1.theme.UNIT(5), theme_1.theme.FILL('text-sidebar'), theme_1.theme.FILL('primary'), function (_a) {
    var isCurrent = _a.isCurrent;
    return isCurrent && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", ";\n      color: ", ";\n    "], ["\n      ", ";\n      color: ", ";\n    "])), theme_1.theme.FILL('dark'), theme_1.theme.COLOR('dark'));
  }, theme_1.theme.COLOR('dark'), theme_1.theme.FILL('dark'))
});
var NameStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    font-weight: 500;\n    font-size: 1em;\n    margin: 0;\n    -webkit-user-select: none;  /* Chrome all / Safari all */\n    -moz-user-select: none;     /* Firefox all */\n    -ms-user-select: none;      /* IE 10+ */\n    user-select: none;          /* Likely future */\n  "], ["\n    display: flex;\n    align-items: center;\n    font-weight: 500;\n    font-size: 1em;\n    margin: 0;\n    -webkit-user-select: none;  /* Chrome all / Safari all */\n    -moz-user-select: none;     /* Firefox all */\n    -ms-user-select: none;      /* IE 10+ */\n    user-select: none;          /* Likely future */\n  "])))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var DisclosureStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    transition: transform 0.3s;\n    ", ";\n    ", "\n\n    ", "\n  "], ["\n    transition: transform 0.3s;\n    ", ";\n    ", "\n\n    ", "\n  "])), theme_1.theme.FILL('text-sidebar'), function (_a) {
    var isOpen = _a.isOpen;
    return isOpen && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      transform: rotate(-180deg);\n    "], ["\n      transform: rotate(-180deg);\n    "])));
  }, function (_a) {
    var isCurrent = _a.isCurrent;
    return isCurrent && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), theme_1.theme.FILL('dark'));
  })
});
var SpinnerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components --------->
var My = {
  Container: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Name: styled_components_1.default.h2(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Label: styled_components_1.default.span(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Disclosure: (0, styled_components_1.default)(icon_1.Icon)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), DisclosureStyles),
  Spinner: (0, styled_components_1.default)(react_spinners_1.ClipLoader)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), SpinnerStyles)
};
var SidebarSectionHeader = function (props) {
  var className = props.className,
    icon = props.icon,
    children = props.children,
    isOpen = props.isOpen,
    onClick = props.onClick,
    isLoading = props.isLoading,
    isCurrent = props.isCurrent,
    isExpandable = props.isExpandable;
  var Icons = (0, use_icons_1.useIcons)();
  // theme functions return a function to evaluate the theme value on a theme object (passed in via context) 
  var spinnerColor = theme_1.theme.COLOR('textTag')(props);
  var SectionIcon = props.icon;
  var DisclosureIcon = Icons.ChevronDown; // isOpen ? Icons.ChevronUp : Icons.ChevronDown;
  return react_1.default.createElement(My.Container, {
    isCurrent: isCurrent,
    onClick: onClick,
    className: className
  }, react_1.default.createElement(My.Name, null, SectionIcon && react_1.default.createElement(My.Icon, {
    size: 18
  }, react_1.default.createElement(SectionIcon, null)), children), isLoading ? react_1.default.createElement(My.Spinner, {
    size: 14,
    color: spinnerColor
  }) : isExpandable && react_1.default.createElement(My.Disclosure, {
    isCurrent: isCurrent,
    isOpen: isOpen,
    size: 10
  }, react_1.default.createElement(DisclosureIcon, null)));
};
exports.SidebarSectionHeader = SidebarSectionHeader;
exports.SidebarSectionHeader.defaultProps = exports.SidebarSectionHeaderDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;